import { CBG_COMP_PACK_MANAGE_COOKIES_HREF } from "@/utilities/cbgCompPackConfig";

type CarlsbergCompliancePack = {
  manageCookies?: () => void;
};

declare global {
  interface Window {
    com_carlsberg_compliance_pack?: CarlsbergCompliancePack;
  }
}

export function isCbgManageCookiesHref(href: string): boolean {
  const trimmed = href.trim();
  if (!trimmed) return false;

  try {
    const url = new URL(trimmed, "https://example.com");
    return url.searchParams.get("cbgManage") === "true";
  } catch {
    return trimmed.includes("cbgManage=true");
  }
}

function tryOpenCbgManageCookies(): boolean {
  const manageCookies = window.com_carlsberg_compliance_pack?.manageCookies;
  if (typeof manageCookies !== "function") return false;

  manageCookies();
  return true;
}

/** Opens the Carlsberg CMP preference UI; polls briefly while the pack loads. */
export function openCbgManageCookies(): void {
  if (tryOpenCbgManageCookies()) return;

  let attempts = 0;
  const intervalId = window.setInterval(() => {
    attempts += 1;
    if (tryOpenCbgManageCookies() || attempts >= 40) {
      window.clearInterval(intervalId);
    }
  }, 250);
}

/** Full navigation fallback when the compliance pack is not available yet. */
export function navigateToCbgManageCookies(): void {
  window.location.assign(CBG_COMP_PACK_MANAGE_COOKIES_HREF);
}
